import { HubRichTextBackground, Maybe } from '@/__generated__/graphql';
import styled, { css, DefaultTheme } from 'styled-components';
import { getBackgroundPatternProperties } from './util';
import { mediaQueries } from '@/theme/lib';

export const StyledPatterns = styled('div')`
`;

export const getGridContainerEdgeStyling = (
  props: { theme: DefaultTheme } & { background?: Maybe<HubRichTextBackground | string>}
) => {
  const backgroundProp = props.background;
  const patternProperties = getBackgroundPatternProperties(backgroundProp);

  const style = css`
    background-color: ${patternProperties.backgroundColor};
    ${patternProperties.backgroundImage ? backgroundPattern(patternProperties.backgroundImage) : ''}
  `;

  return style;
};

export const backgroundPattern = (imageName: string) => css`
  position: relative;
  &::before {
    display: block;
    background-image: url(/BicentenaryPatterns/${imageName});
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    z-index: 1;
  }
  > div {
    z-index: 2;
  }
  > div.wysiwyg {
    position: relative;
    z-index: 2;
  }
`;

export const heroBackgroundPattern = (imageName: string, curveName?: string) => css`
  background-image: url(/BicentenaryPatterns/${imageName});
  background-repeat: no-repeat;
  background-size: cover;
  .hero__wrapper {
      background-image: url(/BicentenaryPatterns/${curveName});
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top left;
      ${mediaQueries.md} {
        background-size: contain;
      }

  }
`;